import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

// Utils
import { capitalizeString } from '../../utils/helpers'

class TabSelect extends Component {
  static propTypes = {
    breakpoint: PropTypes.number.isRequired,
    tabs: PropTypes.array.isRequired,
    currentTabSlug: PropTypes.string.isRequired
  }

  state = {
    windowWidth: 0,
    windowHeight: 0,
    showSelectOptions: false,
    breakpoint: ''
  }

  componentDidMount() {
    this.setBreakpoint(this.props.breakpoint)
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  setBreakpoint(breakpoint) {
    this.setState({
      breakpoint
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState(state => ({
      ...state,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    }), this.hideDropdownOnWindowResize())
  }

  hideDropdownOnWindowResize = () => {
    this.setState(state => ({
      ...state,
      showSelectOptions: window.innerWidth > 880 ? false : null
    }))
  }
  renderDefaultSelectDropdownOption(tabs, currentTabSlug) {
    let selectedTab = tabs.filter((tab) => {
      return tab.slug === currentTabSlug
    })

    return selectedTab.length > 0 ? this.renderTabOption(selectedTab[0], true) : null
  }

  renderTabOption = (tab, isSelectedDropdownOption) => {
    const { currentTabSlug } = this.props

    return isSelectedDropdownOption ?
    (
      <div
        className={`tab-select-options-option dropdown-select-active`}
      >
        { capitalizeString(tab.title) }
      </div>
    )
    : (
      <Link
        className={`tab-select-options-option${tab.slug === currentTabSlug ?  ' active': ''}`}
        key={tab.title}
        to={tab.path}
      >
        { capitalizeString(tab.title) }
      </Link>
    )
  }

  toggleSelect = () => {
    let { showSelectOptions, windowWidth, breakpoint } = this.state

    if (windowWidth <= breakpoint) {
      this.setState(state => ({
        ...state,
        showSelectOptions: !showSelectOptions,
      }))
    }
  }

  getResponsiveStatusClass() {
    const { windowWidth, breakpoint } = this.state

    if (windowWidth <= breakpoint) {
      return ' big-phone'
    } else {
      return ''
    }
  }

  render() {
    const { showSelectOptions } = this.state
    const { tabs, currentTabSlug } = this.props

    if (tabs) {
      return tabs.length > 0 && currentTabSlug
      ? (
        <div
          className={`tab-select${this.getResponsiveStatusClass()}${showSelectOptions ? ' active' : ''}`}
          onClick={ () => this.toggleSelect()}
        >
          <div className="tab-select-options">
            { this.renderDefaultSelectDropdownOption(tabs, currentTabSlug) }
            { tabs.map((tab) => this.renderTabOption(tab)) }
          </div>
        </div>
      )
      : null
    }

  }
}

export default TabSelect


// WEBPACK FOOTER //
// ./src/components/Global/TabSelect.js